import type {
  ThemeColorsBackground,
  ThemeColorsBorder,
  ThemeColorsMeta,
  ThemeColorsMetaIcon,
  ThemeColorsText,
} from '@frameio/vapor-theme';
import { theme } from '@frameio/vapor-theme';

export function getTextColor(color: ThemeColorsText) {
  return theme.colors.text[color] ?? theme.colors.text.interactive[color];
}

export function getBackgroundColor(color: ThemeColorsBackground) {
  return (
    theme.colors.background[color] ??
    theme.colors.background.interactive[color] ??
    color
  );
}

export function getBlurColor(color: ThemeColorsBorder) {
  return theme.colors.blur[color];
}


export function getBorderColor(color: ThemeColorsBorder) {
  return theme.colors.border[color];
}

export function getMetaTextColor(color: ThemeColorsMeta) {
  if (!color || !(color in theme.colors.meta.opaque)) {
    return theme.colors.text.body;
  }
  if (color === 'default') {
    return theme.colors.text.body;
  }
  return theme.colors.meta.text[color];
}

export function getMetaIconColor(color: ThemeColorsMetaIcon) {
  return theme.colors.meta.icon[color];
}